import {
     AfterViewInit,
     Component,
     Inject,
     OnDestroy,
     OnInit,
} from '@angular/core';
import { WsService } from '../../services/ws/ws.service';
import { ToastrService } from 'ngx-toastr';
import { IWsPlanningUserBooking } from '../../services/ws/ws.typings';
import { ITask } from '../planning/planning.component';
import { ActiveBookingListComponent } from '../active-booking-list/active-booking-list.component';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { DataService } from '../../services/data.service';

@Component({
     selector: 'app-active-booking-badge',
     templateUrl: 'active-booking-badge.component.html',
})
export class ActiveBookingBadgeComponent
     implements OnInit, AfterViewInit, OnDestroy {
     activeBookings: IWsPlanningUserBooking[];
     activeBookingsNum = 0;
     taskList: ITask[];
     task$: Subscription;
     userBookings$: Subscription;

     constructor(
          private dialog: MatDialog,
          private ws: WsService,
          private toastrService: ToastrService,
          private dataService: DataService
     ) {}

     ngOnInit() {
          this.task$ = this.dataService.tasks$.subscribe((data) => {
               if (data) {
                    this.taskList = data;
               }
          });
          this.userBookings$ = this.dataService.userBooking$.subscribe(
               (data) => {
                    this.activeBookings = data;
                    this.activeBookingsNum = data.length;
               }
          );
     }

     ngAfterViewInit() {}

     openUserBookings() {
          this.dialog
               .open(ActiveBookingListComponent, {
                    panelClass: 'dialog--no-padding',
                    data: {
                         activeBookings: this.activeBookings,
                         tasks: this.taskList,
                    },
               })
               .afterClosed();
     }

     ngOnDestroy() {
          if (this.task$ && this.task$.unsubscribe) {
               this.task$.unsubscribe();
          }
          if (this.userBookings$ && this.userBookings$.unsubscribe) {
               this.userBookings$.unsubscribe();
          }
     }
}
